import React from "react";

export const LinkDefault = ({ data, icon, className, ...others }) => {
    if (!data) return null;

    const css = `flex items-center text-skin-primary ${className}`;

    return (
        <a href={data.url} className={css} {...others}>
            {data.text}
            {icon ? <span className="ml-1">{icon}</span> : ""}
        </a>
    );
};
